import { ReactNode } from 'react';

type Variant = 'success' | 'warning' | 'danger' | 'info' | 'default';
type ColorName = 'blue' | 'green' | 'purple' | 'gray' | 'red' | 'yellow';

interface BadgeProps {
  children: ReactNode;
  variant?: Variant;
  color?: ColorName;
  className?: string;
  /** Native tooltip, e.g. to explain a warning. */
  title?: string;
}

const VARIANT_CLASSES: Record<Variant, string> = {
  success: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  warning: 'bg-amber-50 text-amber-700 border border-amber-200',
  danger: 'bg-red-50 text-red-700 border border-red-200',
  info: 'bg-sky-50 text-sky-700 border border-sky-200',
  default: 'bg-slate-100 text-slate-600',
};

const COLOR_CLASSES: Record<ColorName, string> = {
  blue: 'bg-blue-50 text-blue-700 border border-blue-200',
  green: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  purple: 'bg-violet-50 text-violet-700 border border-violet-200',
  gray: 'bg-slate-100 text-slate-600',
  red: 'bg-red-50 text-red-700 border border-red-200',
  yellow: 'bg-amber-50 text-amber-700 border border-amber-200',
};

export function Badge({ children, variant, color, className = '', title }: BadgeProps) {
  const tone = color ? COLOR_CLASSES[color] : VARIANT_CLASSES[variant ?? 'default'];
  return (
    <span
      title={title}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap ${tone} ${className}`}
    >
      {children}
    </span>
  );
}

export default Badge;
